import type { ReactNode } from 'react';

import { ToastProvider, ToastViewport } from '@/shared/ui/feedback/Toast';
import { TooltipProvider } from '@/shared/ui/primitives/Tooltip';

/**
 * Radix providers that must wrap the tree once (tooltip, toast viewport).
 */
export function UiProvider({ children }: { children: ReactNode }) {
  return (
    <TooltipProvider delayDuration={400} skipDelayDuration={0}>
      <ToastProvider swipeDirection="right" duration={5000}>
        {children}
        <ToastViewport />
      </ToastProvider>
    </TooltipProvider>
  );
}
